<!-- <app-header></app-header> -->
<app-content-tabs [hidden]="path === 'imagine' || path === 'theWorldAsOne'"></app-content-tabs>

<div class="route-container"  [@routeAnimations]="prepareRoute()" >
    <router-outlet></router-outlet>
</div>
